/* eslint-disable no-undef */
import { getLink } from '@/views/loan/lib'
import Vue from 'vue'

async function openLinkInNewWindow () {
  const type = process.env.VUE_APP_TYPE
  let newWindow
  try {
    if (type === 'webios') {
      this.$eventTrack({
        pageName: 'OpenPage-refused',
        action: 'addPwa-refused'
      })
      if (localStorage.getItem('x-auth-token') && localStorage.getItem('userId')) {
        window.location.href = this.$addPwaUrlParams(process.env.VUE_APP_LINK)
      } else {
        window.location.href = process.env.VUE_APP_LINK + '?adid=' + encodeURIComponent(this.$aesEncrypt(localStorage.getItem('adid')))
      }
    } else {
      newWindow = window.open('', '_blank')
      const res = await getLink()
      const url = res && res.data
      this.$eventTrack({
        pageName: 'OpenPage-refused',
        action: 'addApp-refused'
      })
      if (url) {
        const formatted = `https://${url}`
        newWindow.location.href = formatted
      } else {
        newWindow && newWindow.close()
      }
    }
  } catch (e) {
    if (type !== 'webios' && newWindow) {
      newWindow.close()
    }
  }
}

Vue.prototype.$openLinkInNewWindow = openLinkInNewWindow
export default {
  openLinkInNewWindow
}
